/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { deleteLayer } from "../../App/actions/layerNewActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const DeleteLayer = ({
  layer,
  auth,
  project,
  toggle_delete_layer,
  deleteLayer,
}) => {
  const { geo_layer_wo_geojson, map_object, loadingProcess } = layer;
  const { geo_project } = project;

  const handleSubmit = () => {
    //hapus layer dengan API ke DB
    const geo_layer_id = geo_layer_wo_geojson?.geo_layer?._id;

    if (geo_layer_id) {
      toggle_delete_layer();
      const body = {
        geo_project_id: geo_project._id,
        geo_layer_id,
      };
      deleteLayer(body);

      //hapus layer dari map
      if (map_object) {
        //layer original
        if (map_object.getLayer(geo_layer_id)) {
          map_object.removeLayer(geo_layer_id);
        }
        //layer line outline untuk layer poligon
        if (map_object.getLayer(`${geo_layer_id}_line_polygon`)) {
          map_object.removeLayer(`${geo_layer_id}_line_polygon`);
        }
        //layer cluster untuk point
        if (map_object.getLayer(`${geo_layer_id}_cluster`)) {
          map_object.removeLayer(`${geo_layer_id}_cluster`);
        }
        //layer cluster container untuk point
        if (map_object.getLayer(`${geo_layer_id}clusters_container`)) {
          map_object.removeLayer(`${geo_layer_id}clusters_container`);
        }
        //layer cluster_count_number untuk point
        if (map_object.getLayer(`${geo_layer_id}cluster_count_number`)) {
          map_object.removeLayer(`${geo_layer_id}cluster_count_number`);
        }
        //source original
        if (map_object.getSource(geo_layer_id)) {
          map_object.removeSource(geo_layer_id);
        }
        //source cluster untuk point
        if (map_object.getSource(`${geo_layer_id}_cluster`)) {
          map_object.removeSource(`${geo_layer_id}_cluster`);
        }
      }
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  let buttonContent;
  if (loadingProcess) {
    buttonContent = (
      <div className="button background_grey">
        {dict["Process deletion"][language]}...
      </div>
    );
  } else {
    buttonContent = (
      <button className="button hover_danger" onClick={handleSubmit}>
        {dict["Process deletion"][language]}
      </button>
    );
  }

  const itemContent = (
    <div>
      <p className="text_medium sub_color margin_bottom">
        {
          dict[
            "Layer(s) will be kept in the Recovery place for 30 days before being permanently deleted automatically"
          ][language]
        }
      </p>
      <div className="text_bold margin_bottom_extra">
        {geo_layer_wo_geojson?.geo_layer?.name}
      </div>
      {buttonContent}
    </div>
  );

  return <div>{itemContent}</div>;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, { deleteLayer })(DeleteLayer);
